<template>
  <div>
    <div v-if="openType === 0"></div>
    <div v-else>
      <el-form style="margin: 20px 40px 0 0" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="120px" class="demo-ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="老人" prop="pId">
              <el-select v-fixZoom v-model="addEditForm.pId" filterable placeholder="请选择" :clearable="true" style="width:100%;" @change="elderlyChange">
                <el-option v-for="item in elderlyArr" :key="item.index" :label="item.name" :value="item.id">
                  <span>{{ getSelectElderlyShow(item) }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="">
              <el-input disabled v-model="addEditForm.pIdCardNum" placeholder=""></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开始时间" prop="beginTime">
              <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.beginTime"
                              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker v-fixZoom style="width: 100%" v-model="addEditForm.endTime"
                              type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="xxxx-xx-xx xx:xx:xx" :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称" prop="goodsName">
              <el-input v-model="addEditForm.goodsName" placeholder="输入物品名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数量" prop="goodsCount">
              <el-input v-model="addEditForm.goodsCount" placeholder="输入物品数量"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="goodsStatus">
              <el-select v-fixZoom disabled v-model="addEditForm.goodsStatus" filterable placeholder="请选择" style="width: 100%">
                <el-option v-for="item in goodsStatusArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="办理人员" prop="">
              <el-input disabled v-model="espName" placeholder=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="height: 50px">
      <el-row v-if="openType !== 0" style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
      <el-row v-else style="margin: 0 20px">
        <div class="cancel-btn" style="float: right" @click="closeAddEdit()">
          <span>关闭</span>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import {queryelderlyhasbed} from '../../../api/yanglaoyuan/elderly'
import {creategoodsperson, updategoodsperson} from '../../../api/yanglaoyuan/goodsperson'

export default {
  name: 'addEditGoodsEscrow',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    goodsObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      eId: 0,
      espId: 0,
      espName: '',
      // 打开类型 0查看 1新增 2编辑 3确认
      openType: 0,
      row: '',
      elderlyArr: [],
      goodsStatusArr: [],
      pickerOptions: {},

      addEditForm: {
        pIdCardNum: '',
        pId: '',
        beginTime: '',
        endTime: '',
        goodsName: '',
        goodsCount: '',
        goodsStatus: 1
      },
      addEditRules: {
        pId: [{required: true, message: '请选择老人', trigger: 'change'}],
        goodsName: [{ required: true, message: '请输入物品名称', trigger: 'blur' }],
        goodsCount: [{ required: true, message: '请输入物品数量', trigger: 'blur' }],
        goodsStatus: [{ required: true, message: '请选择物品状态', trigger: 'change' }],
        beginTime: [{required: true, message: '请选择开始时间', trigger: 'change'}],
        endTime: [{required: true, message: '请选择结束时间', trigger: 'change'}]
      }
    }
  },
  created () {
    this.getStartData()
  },
  methods: {
    getStartData () {
      let loginResp = this.$store.state.user.LoginResp
      this.eId = loginResp.entity_id
      this.espId = loginResp.syspersonid
      this.espName = loginResp.personname
      this.goodsStatusArr = this.commonType.getGoodsStatusArr()

      this.openType = this.goodsObj.openType
      this.row = this.goodsObj.row
      if (this.openType === 1 || this.openType === 2) {
        this.getElderlyData()
      }

      if (this.openType === 2) {
        this.addEditForm.pId = this.row.pid
        this.addEditForm.goodsName = this.row.goods_name
        this.addEditForm.goodsCount = this.row.goods_count
        this.addEditForm.goodsStatus = this.row.goods_status
        this.addEditForm.beginTime = this.row.begin_time
        this.addEditForm.endTime = this.row.end_time
      }
    },
    getSelectElderlyShow (item) {
      let elderlyName = item.name && item.name !== '' ? item.name : '--'
      let buildName = item.build_name && item.build_name !== '' ? item.build_name : '--'
      let floorName = item.floor_name && item.floor_name !== '' ? item.floor_name : '--'
      let roomName = item.room && item.room !== '' ? item.room : '--'
      let bedName = item.bed_name && item.bed_name !== '' ? item.bed_name : '--'
      return elderlyName + ' / ' + buildName + '--' + floorName + '--' + roomName + '--' + bedName
    },

    elderlyChange () {
      let elderly = this.elderlyArr.find(r => r.id === this.addEditForm.pId)
      if (elderly) {
        this.addEditForm.pIdCardNum = elderly.idcard_num
      }
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.openType === 1) {
            this.sendAdd()
          } else if (this.openType === 2) {
            this.sendEdit()
          }
        }
      })
    },
    sendAdd () {
      let data = {
        e_id: this.eId,
        pid: this.addEditForm.pId,
        epid: this.addEditForm.pId,
        goods_name: this.addEditForm.goodsName,
        goods_count: this.addEditForm.goodsCount,
        goods_status: this.addEditForm.goodsStatus,
        begin_time: this.addEditForm.beginTime,
        end_time: this.addEditForm.endTime
      }
      creategoodsperson(data).then(res => {
        this.$notify({title: '成功', message: '成功新增代管物品', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },
    sendEdit () {
      let data = {
        id: this.row.id,
        e_id: this.eId,
        pid: this.addEditForm.pId,
        epid: this.addEditForm.pId,
        goods_name: this.addEditForm.goodsName,
        goods_count: this.addEditForm.goodsCount,
        goods_status: this.addEditForm.goodsStatus,
        begin_time: this.addEditForm.beginTime,
        end_time: this.addEditForm.endTime
      }
      updategoodsperson(data).then(res => {
        this.$notify({title: '成功', message: '成功修改代管物品', type: 'success', duration: 2000})
        this.$emit('updateTable')
        this.$emit('change', false)
      })
    },

    // 访问接口
    // 查询老人
    async getElderlyData () {
      let data = {
        e_id: this.eId
      }
      await queryelderlyhasbed({}, data).then(res => {
        this.elderlyArr = res.data.elderly
        if (this.openType === 2) {
          let elderly = this.elderlyArr.find(r => r.id === this.addEditForm.pId)
          if (elderly) {
            this.addEditForm.pIdCardNum = elderly.idcard_num
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditGoodsEscrow.vue